import { ThunkDispatchProp } from "../../models/actions/ThunkDispatchProp";
import { AxisModel } from "../../models/AxisModel";
import { variableForCell } from "../../models/utilities/gridUtilities";
import { enableAllMappedVariablesFieldStatus } from "../../redux/actions";
import { evaluateIsVariableVisible } from "../../redux/thunks/evaluator";
import { BaseControl, ControlProps } from "./BaseControl";

export abstract class BaseGridControl<
    P extends ControlProps & ThunkDispatchProp,
    S,
> extends BaseControl<P, S> {
    onShouldHideCell = (row: AxisModel, column: AxisModel) => {
        const variable = variableForCell(row, column);
        if (!variable || variable.skipLogic == null) {
            return false;
        }
        const { dispatch } = this.props;
        const isHidden = !dispatch(evaluateIsVariableVisible(variable));

        if (isHidden) {
            if (this.hasMentions(this.props, variable.name)) {
                const variableAllMentions = this.getLatestMentionsForVariableName(variable.name);
                dispatch(enableAllMappedVariablesFieldStatus(variable.name, variableAllMentions));

                this.setMentions(this.props, variable.name, (m) => m.clear());
            }
        }

        return isHidden;
    };
}
